module.exports = __webpack_public_path__ + "image/ewm2.png";